module.exports = __webpack_public_path__ + "static/survival_weeks-c8d5fcfa79ef8329b74aa9f5aac09aed.jpg";